module.exports = __webpack_public_path__ + "img/SKWINKELNetActieKPIA1BD39.8b08c070.png";